import { createContext } from 'react';
import useCases from './useCases';
import useCollections from './useCollections';
import useModal from './useModal';
import useUI from './useUI';
import useWorkspaces from './useWorkspaces';
import useReport from './useReport';
import useAdmin from './useAdmin';
import useNotifications from './useNotifications';
import useTags from './useTags';

interface GlobalCtx {
    casesData: ReturnType<typeof useCases>;
    workspacesData: ReturnType<typeof useWorkspaces>;
    dialog: ReturnType<typeof useModal>;
    uiData: ReturnType<typeof useUI>;
    collectionData: ReturnType<typeof useCollections>;
    reportData: ReturnType<typeof useReport>;
    adminData: ReturnType<typeof useAdmin>;
    tagsData: ReturnType<typeof useTags>;
    notificationsData: ReturnType<typeof useNotifications>;
}

const GlobalContextProvider = ({ children }) => {
    const uiData = useUI();
    const dialog = useModal();
    const workspacesData = useWorkspaces(dialog);
    const casesData = useCases(workspacesData.activeWorkspace?.id);
    const reportData = useReport(workspacesData.activeWorkspace, casesData.activeCaseId);
    const adminData = useAdmin(workspacesData.activeWorkspace?.id);
    const tagsData = useTags(casesData.activeCaseId, workspacesData.activeWorkspace?.id, reportData.streamId);
    const notificationsData = useNotifications(workspacesData.activeWorkspace?.id);
    const collectionData = useCollections(
        casesData.activeCaseId,
        workspacesData.activeWorkspace?.id,
        reportData.streamId,
    );

    return (
        <GlobalContext.Provider
            value={{
                casesData,
                workspacesData,
                dialog,
                uiData,
                collectionData,
                reportData,
                adminData,
                tagsData,
                notificationsData,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};

export const GlobalContext = createContext({} as GlobalCtx);
export default GlobalContextProvider;
